import React, { useEffect, useState } from "react";
import moment from "moment";
import { getTimeZoneDate } from "../../../helpers/data-format";
import Timeline, {
  CustomHeader,
  DateHeader,
  TimelineHeaders,
  TimelineMarkers,
  TodayMarker,
  CustomMarker,
  CursorMarker,
} from "react-calendar-timeline";
import "react-calendar-timeline/lib/Timeline.css";
import "./style.css";
import itemRender, { ProgressLegend } from "./itemRender";
import SundaysMarker from "./SundaysMarker";
import groups from "./groups";
import keys from "./keys";
import { Box,  } from "@mui/material";
import { useJwt } from "../../../helpers/common";
import { useOrganizationService } from '../../../services';
import { useSelector } from 'react-redux';

import { useXarrow } from 'react-xarrows';
const Calender = ({sim_flag,singleRoadmapRes={},loading,viewType,handleProjectClick}) => {
  const items = []
  const updateXarrow = useXarrow();
   const [state,setState] = useState({
    keys,
    groups,
    items,
    y19: new Date(),
    visibleTimeStart: moment(new Date()).add(-1, "month").valueOf(),
    visibleTimeEnd: moment(new Date()).add(1, "month").valueOf(),
    checked: false,
  })
  const [_curItems,setItems] = useState([])
  const JWTdata = useJwt();
  const org_id = JWTdata.org_id;
  const { fetchOrgSchedule } = useOrganizationService();

  const { 
    orgSchedule=[],
    orgScheduleLoading=false
  } = useSelector((state) => state.organization);

  useEffect(()=>{
    if(org_id){
      fetchOrgSchedule(org_id)
    }
  },[org_id]);

  useEffect(() => {
    const currentTime = moment(); // Current date and time
    let visibleTimeStart, visibleTimeEnd;
    // Adjust visible range based on viewType
    switch (viewType) {
      case "week":
        visibleTimeStart = currentTime.subtract(3, "days").valueOf();
        visibleTimeEnd = currentTime.add(7, "days").valueOf();
        break;

      case "month":
        visibleTimeStart = currentTime.subtract(15, "days").valueOf();
        visibleTimeEnd = currentTime.add(30, "days").valueOf();
        break;

      case "quarter":
        visibleTimeStart = currentTime.subtract(1, "months").valueOf();
        visibleTimeEnd = currentTime.add(3, "months").valueOf();
        break;

      case "year":
        visibleTimeStart = currentTime.subtract(6, "months").valueOf();
        visibleTimeEnd = currentTime.add(12, "months").valueOf();
        break;

      default:
        // Default to a week view if viewType is unknown
        visibleTimeStart = currentTime.subtract(3, "days").valueOf();
        visibleTimeEnd = currentTime.add(7, "days").valueOf();
    }

    const data = {
      ...state,
      visibleTimeStart,
      visibleTimeEnd,
    };

    setState(data);
  }, [viewType]);

  
  useEffect(()=>{
    if(!loading && singleRoadmapRes.length){
      const data = {...state}
      const itemData =  [..._curItems]
      const di = itemData.map((item) => ({
        ...item,
        checked: sim_flag,
        end: sim_flag
          ? moment(item.end).add(item.addedTime.days, "day")
          : item.end,
      }))
      data["checked"] = sim_flag
      data["items"] = di
      setState(data)
    }
    
  },[sim_flag,loading,singleRoadmapRes])


  useEffect(()=>{
    const {projects=[]} = singleRoadmapRes;
    const oldState = {...state}

    const items = []
    if(projects.length){
      projects.forEach((project,index)=>{
        items.push({
          ...project,
          id: project.project_id,
          group: index+1,
          title: project.project_name,
          tip:project.project_description,
          start: sim_flag ? moment(project?.sim_data?.start_date) : moment(project.start_date),
          end: sim_flag ? moment(project?.sim_data?.end_date) : moment(project?.end_date),
          canMove: true,
          canResize: true,
          canChangeGroup: false,
          complete: project.progress || 0,
          checked: sim_flag,
          simulation_cost: project.sim_data.project_cost,
          days: project.sim_data.duration - project.duration,
          className:"dark:!bg-slate-800 !bg-gray-300 !text-white !border-gray-400 dark:!border-gray-700",
          
        })
      })
      const group = projects.map((item,index) => {
        return {
          id:index+1
        }
      })
      oldState["items"] = items;
      oldState["groups"] = [...group,...[{id:"cad2"}]];
      setState(oldState)
      setItems(items)
      setTimeout(()=>{
        updateXarrow()
      },100)
      
    }

    
  },[singleRoadmapRes,sim_flag])

  const handleTimeChange = (visibleTimeStart, visibleTimeEnd, updateScrollCanvas) => {
    setState({...state, visibleTimeStart, visibleTimeEnd });
    setTimeout(()=>{
      updateXarrow()
    },100)
  };

  let  labelFormat = "MMMM";
  let itemHeightRatio = 0.45
  let lineHeight = 100
  if(viewType === "week"){
    labelFormat = "DD MMMM";
    lineHeight=70
  }
  if(viewType === "month"){
    labelFormat = "DD";
    lineHeight=70
  }
  if(viewType === "quarter"){
    labelFormat = "MMMM YYYY";
    lineHeight=70
  }
  if(viewType === "year"){
    itemHeightRatio=0.8
    lineHeight=70
  }
  const {milestones = []} = singleRoadmapRes;

  // Add these zoom constraints based on view type
  let minZoom, maxZoom;
  switch(viewType) {
    case "week":
      minZoom = 24 * 60 * 60 * 1000; // 1 day
      maxZoom = 7 * 24 * 60 * 60 * 1000; // 7 days
      break;
    case "month":
      minZoom = 7 * 24 * 60 * 60 * 1000; // 7 days
      maxZoom = 31 * 24 * 60 * 60 * 1000; // 31 days
      break;
    case "quarter":
      minZoom = 31 * 24 * 60 * 60 * 1000; // 31 days
      maxZoom = 92 * 24 * 60 * 60 * 1000; // ~3 months
      break;
    case "year":
      minZoom = 92 * 24 * 60 * 60 * 1000; // ~3 months
      maxZoom = 366 * 24 * 60 * 60 * 1000; // 1 year
      break;
    default:
      minZoom = 31 * 24 * 60 * 60 * 1000;
      maxZoom = 92 * 24 * 60 * 60 * 1000;
  }

  if(!state.items.length) {
    return (
      <Box className="SubHeaderBtnWrapper">
        No Data Found 
      </Box>
    )
  }

    return (
      <>
        <div className="relative h-full">
          <Timeline
            keys={state.keys}
            groups={state.groups}
            items={
              state.items
            }
            lineHeight={70}
            itemRenderer={(e) =>
              itemRender({
                ...e,
                checked:state.checked,
                sim_flag,
                handleProjectClick,
                updateXarrow
              })
            }
            defaultTimeStart={moment(state.y19).add(-1, viewType)}
            defaultTimeEnd={moment(state.y19).add(1, viewType)}
            minZoom={minZoom}
            maxZoom={maxZoom}
            fullUpdate={false}
            itemTouchSendsClick={
              false
            }
            stackItems={true}
            itemHeightRatio={0.6}
            showCursorLine
            canMove={true}
            canResize={"both"}
            sidebarWidth={0}
            horizontalLineClassNamesForGroup={() => ["bg-slate-800"]}
            onTimeChange={handleTimeChange}
            visibleTimeStart={state.visibleTimeStart}
            visibleTimeEnd={state.visibleTimeEnd}
            timeSteps={{
              second: 1,
              minute: 30,
              hour: 2,
              day: 1,
              month: 1,
              year: 1
            }}
          >
            <TimelineHeaders className="sticky">
              <DateHeader 
                unit="primaryHeader"
                labelFormat={"YYYY"}
                style={{
                  backgroundColor: "#a0acbd",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "13px",
                  fontWeight: "600",
                  color: "#FFFFFF",
                  borderBottom: "1px solid #374151",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  minWidth: "80px"
                }}
              />
              <DateHeader 
                unit="month"
                labelFormat={"MMMM"}
                style={{
                  backgroundColor: "#a0acbd",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "12px",
                  fontWeight: "500",
                  color: "#FFFFFF",
                  borderBottom: "1px solid #374151",
                  borderLeft: "1px solid #374151",
                  minWidth: "60px"
                }}
                intervalRenderer={({ getIntervalProps, intervalContext }) => {
                  return (
                    <div
                      {...getIntervalProps()}
                      className="rct-dateHeader"
                      style={{
                        ...getIntervalProps().style,
                        backgroundColor: "#a0acbd",
                        color: "#FFFFFF",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderLeft: "1px solid #374151",
                        fontSize: "16px",
                        whiteSpace: "nowrap",
                        padding: "0 12px"
                      }}
                    >
                      {intervalContext.intervalText}
                    </div>
                  );
                }}
              />
              {(viewType === "quarter" || viewType === "week" || viewType === "month") && (
                <CustomHeader unit="day">
                  {({headerContext: { intervals }, getRootProps, getIntervalProps}) => (
                    <div {...getRootProps()} className="bg-slate-900">
                      {intervals.map((interval) => {
                        const intervalStyle = {
                          height: "28px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderLeft: "1px solid #374151",
                          color: "#FFFFFF",
                          fontSize: "11px",
                          backgroundColor: "#1E293B",
                          minWidth: "16px",
                          fontWeight: "600"
                        };
                        
                        const isWeekend = interval.startTime.day() === 0 || interval.startTime.day() === 6;
                        if (isWeekend) {
                          intervalStyle.backgroundColor = "#1E293B";
                          intervalStyle.color = "rgb(107 126 152)";
                          intervalStyle.fontWeight = "600";
                        }
                        
                        return (
                          <div
                            {...getIntervalProps({
                              interval,
                              style: intervalStyle
                            })}
                          >
                            {interval.startTime.format("D")}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </CustomHeader>
              )}
            </TimelineHeaders>
            <TimelineMarkers>
              <TodayMarker>
                {({ styles, date }) => (
                  <div
                    style={{
                      ...styles,
                      borderLeft:2,
                      backgroundColor:"transparent",
                      borderColor:"#3BAA53",
                      borderStyle:"solid",
                      width:"100px",
                    }}
                  >
                    <span className="text-[10px] bg-slate-700 border border-[#3BAA53] p-2 absolute top-0 rounded-sm ">{getTimeZoneDate(date,"DD MMM")}</span>
                  </div>
                )}
              </TodayMarker>
              {milestones.length ? milestones.map(milestone=>{
                return (
                    <CustomMarker
                      date={getTimeZoneDate(milestone.start_date)}
                    >
                      {({ styles, date }) => (
                        <div
                          style={{
                            ...styles,
                            borderLeft:2,
                            backgroundColor:"transparent",
                            borderColor:milestone.color,
                            borderStyle:"solid",
                            width:"100px",
                          }}
                        >
                          <span 
                            className="text-[10px] bg-slate-700 p-2 absolute top-0 rounded-sm border"
                            style={{
                              borderColor: milestone.color
                            }}
                          >
                            {milestone.name}
                          </span>
                        </div>
                      )}
                    </CustomMarker>
                  )
              }) : ""}
              {orgSchedule.length && viewType !== "year" ? orgSchedule.map(schedule=>{
                return (
                    <CustomMarker
                      date={getTimeZoneDate(schedule.date)}
                    >
                      {({ styles, date }) => (
                        <div
                          style={{
                            ...styles,
                            borderLeft:2,
                            backgroundColor:"transparent",
                            borderColor:"#FFA500",
                            borderStyle:"solid",
                            width:"100px",
                          }}
                        >
                          <span className={`text-[10px] bg-slate-700 p-2 absolute top-0 rounded-sm border`} style={{borderColor:"#FFA500"}}>{schedule.name}</span>
                        </div>
                      )}
                    </CustomMarker>
                  )
              }) : ""}
              <CursorMarker >
                {({ styles, date }) => (
                    <div
                      style={{
                        ...styles,
                        borderLeft:2,
                        backgroundColor:"transparent",
                        borderColor:"#000",
                        borderStyle:"solid",
                        width:"150px"
                      }}
                    >
                      <span className="text-[10px] bg-slate-700 p-2 rounded-sm">{getTimeZoneDate(date,"DD MMM")}</span>
                    </div>
                  )}
              </CursorMarker>
              <SundaysMarker />
            </TimelineMarkers>
          </Timeline>
          <ProgressLegend />
        </div>
      </>
    );
  
}

export default Calender;
